import React from 'react';
import styles from './Simple.module.css';

// Presentation only. Data and actions stay with the consuming page.
export default function SimplePanel({ as: Element = 'section', className = '', children, ...props }) {
  return <Element className={`${styles.panel} ${className}`} {...props}>{children}</Element>;
}
